//SCREENSHOT_LIST
export const USER_ID_SCREENSHOT_REQUEST = 'USER_ID_SCREENSHOT_REQUEST';
export const USER_ID_SCREENSHOT_SUCCESS = 'USER_ID_SCREENSHOT_SUCCESS';
export const USER_ID_SCREENSHOT_FAIL = 'USER_ID_SCREENSHOT_FAIL';
//ALL_SCREENSHOT_LIST
export const USER_ID_ALL_SCREENSHOT_REQUEST = 'USER_ID_ALL_SCREENSHOT_REQUEST';
export const USER_ID_ALL_SCREENSHOT_SUCCESS = 'USER_ID_ALL_SCREENSHOT_SUCCESS';
export const USER_ID_ALL_SCREENSHOT_FAIL = 'USER_ID_ALL_SCREENSHOT_FAIL';
